import {
  WidgetInstance,
} from 'mobx-store/stores/customScreens/types';
import { ValidationOptionsKeys } from 'screens/addEditCustomScreen/types';
import { ValidationSchema } from '../validation.helper';

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: any) => void;
  handleMultipleChangeData: (params: {}) => void;
  removeFocusedWidget: () => void;
}

export enum imageWidgetType {
  STATIC='static',
  INTENAL='internal',
  EXTERNAL='external',
}

export enum ColorPalette {
  ERROR="error",
  PRIMARY="primary",
  SURFACE="surface",
};

export enum TitleAlignment {
  TOP = "top",
  CENTER = "center",
  BOTTOM = "bottom",
};


export const imageWidgetValidation: ValidationSchema =  {
  title: [],
  imageURL: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  isExternalTitle: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  titleColor: [{
     validation: [ValidationOptionsKeys.REQUIRED],
     case: {
       key: 'isExternalTitle',
       value: 'false'
     }
    }],
  isHorizontalCenter:  [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'isExternalTitle',
      value: 'false'
    }
   }],
  titleAlignment:  [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'isExternalTitle',
      value: 'false'
    }
   }],
  cardActionType: [{
          validation: [ValidationOptionsKeys.REQUIRED],    
  }],
  cardActionExternalLink: [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'cardActionType',
      value: imageWidgetType.EXTERNAL
    }
  }],
  cardActionParams: [],
  cardActionRedirect: [{
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'cardActionType',
        value: imageWidgetType.INTENAL
      }
  }],
  cardActionEntityId: [],
  cardActionStaticTitle: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'cardActionType',
        value: imageWidgetType.STATIC
      }
    }
  ],
  cardActionStaticDescription: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'cardActionType',
        value: imageWidgetType.STATIC
      }
    }
  ],
  descriptionTitle: [],
  descriptionSubTitle: [],
  descriptionLabel: [],
  descriptionLabelColor: [],
  iconImage: []
}